import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { textStyle } from '../v2/theme';
import { PnmacSection, PnmacActivityRow, PnmacTextMobile } from 'pnmac-universal-components';
import { currencyFormatter } from '../utils.js';
var Transaction = /** @class */function (_super) {
  __extends(Transaction, _super);
  function Transaction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Transaction.prototype.render = function () {
    var _a = this.props,
      translations = _a.translations,
      locale = _a.locale,
      transaction = _a.transaction,
      rowStyle = _a.rowStyle,
      props = __rest(_a, ["translations", "locale", "transaction", "rowStyle"]);
    return /*#__PURE__*/React.createElement(PnmacSection.Row, {
      style: __assign(__assign({}, rowStyle), {
        borderTopLeftRadius: this.props.topLeftRadius,
        borderTopRightRadius: this.props.topRightRadius,
        borderBottomLeftRadius: this.props.botLeftRadius,
        borderBottomRightRadius: this.props.botRightRadius,
        paddingLeft: 3
      }),
      last: props.last
    }, /*#__PURE__*/React.createElement(PnmacActivityRow, {
      date: transaction === null || transaction === void 0 ? void 0 : transaction.effectiveDate,
      mainInfo: locale === 'es' ? transaction === null || transaction === void 0 ? void 0 : transaction.spanishTransactionCodeDesc : transaction === null || transaction === void 0 ? void 0 : transaction.transactionCodeDesc,
      secondaryInfo: (transaction === null || transaction === void 0 ? void 0 : transaction.transactionGroupCode) == 20 && this.props.escrowFlag ? "".concat(translations.escrowBalance, ": ").concat(currencyFormatter('en-US', 'currency', 'USD', transaction === null || transaction === void 0 ? void 0 : transaction.escrowBalance)) : "".concat(translations.principalBalance, ": ").concat(currencyFormatter('en-US', 'currency', 'USD', transaction === null || transaction === void 0 ? void 0 : transaction.principalBalance)),
      rightInfo: /*#__PURE__*/React.createElement(PnmacTextMobile, __assign({
        style: textStyle.formBody,
        heavy: true
      }, (transaction === null || transaction === void 0 ? void 0 : transaction.transactionAmount) > 0 ? {
        green: true
      } : {
        darkGray: true
      }), currencyFormatter('en-US', 'currency', 'USD', transaction === null || transaction === void 0 ? void 0 : transaction.transactionAmount)),
      onPress: function () {
        return props.onTransactionPress(transaction);
      },
      secondaryInfoEllipsizeMode: props.secondaryInfoEllipsizeMode
    }));
  };
  return Transaction;
}(React.PureComponent);
export default Transaction;